import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DownloadGuide from './components/DownloadGuide';
import CategoriesPreview from './components/CategoriesPreview';
import ArticlesPreview from './components/ArticlesPreview';
import FAQSection from './components/FAQSection';
import HomeStructuredData from './components/StructuredData';

export default function Home() {
  return (
    <>
      <HomeStructuredData />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <DownloadGuide />
        <CategoriesPreview />
        <ArticlesPreview />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}